var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6697 12.0797L9.59 8L13.6697 3.92034C14.1101 3.47989 14.1101 2.77079 13.6697 2.33034C13.2292 1.88989 12.5201 1.88989 12.0797 2.33034L8 6.41L3.92034 2.33034C3.47989 1.88989 2.77079 1.88989 2.33034 2.33034C1.88989 2.77079 1.88989 3.47989 2.33034 3.92034L6.41 8L2.33034 12.0797C1.88989 12.5201 1.88989 13.2292 2.33034 13.6697C2.77079 14.1101 3.47989 14.1101 3.92034 13.6697L8 9.59L12.0797 13.6697C12.5201 14.1101 13.2292 14.1101 13.6697 13.6697C14.107 13.2292 14.107 12.517 13.6697 12.0797Z",
    fill: "#9E9E9E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClose);
export default __webpack_public_path__ + "static/media/icon-close.1ee04f6567dbfbdc8fffa37c669a8660.svg";
export { ForwardRef as ReactComponent };